/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js';
import con from '@/firebase/firebaseInit.ts';
import ls from "@/common/localStorage";
//const cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
const virtuallobbyRef = con.eventDB.collection(cn).doc('VirtualLobby');
const eventInfoRef = con.eventDB.collection(cn).doc('EventInfo');
const storageRef = con.storageRef;
//const clientRef = con.instanceDB.doc("ClientList").collection("Clients").doc();
const virtualLobbyTemplates = con.instanceDB.doc("VirtualLobbyTemplate").collection("Lobby");
const EventCollectionName = ls.getSessionEventCollectionName();
export default {

    fetchVirtuallobby(context, id) {
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        CountDownTime: '',
                        MusicURL: '',
                        IsBackgroundMusic: 'true',
                        VideoURL: '',
                        VideoLength: 5,
                        IsVideoControl: 'true',
                        AutoRedirectMicrositeWhenCountdownCompleted: 'Disable',
                        RedirectURL: '',
                        PhotoScrollerLeft: '',
                        PhotoScrollerRight: '',
                        ImgHotspotHTML: '',
                        PhotoScrollLeftHeading: '',
                        PhotoScrollRightHeading: '',
                        LastModifiedDate: '',
                        HidePhotoScrollLeft: 'ShowPhotoScrollLeftHide',
                        HidePhotoScrollRight: 'ShowPhotoScrollRightHide',
                        HideBottomMenu: 'false',
                        headlineText: '',
                        hostedBy: '',
                        coundownLobby: {
                            bgImageApp: "",
                            bgImagePath: "",
                            bgImageIpad: "",
                            HeaderTextColor: "#ffffff",
                            sponsorBorderColor: "#500a48",
                            sponsorBGColor: "#000000",
                            photoWallBorderColor: "rgba(255, 255, 255, 0.29)",
                            photoWallBGColor: "rgba(255, 255, 255, 0.29)",
                            joinButtonBGColor: "#19852e",
                            joinButtonShadowColor: "#0d551b",
                            joinButtonFontColor: "#ffffff",
                            navcolor: "#ffffff"
                        },

                        AdditionalButtons: {
                            LeftSubButtonLabel: "Attendees",
                            LeftSubButtonURL: "/attendee",
                            MiddleSubButtonLabel: "Speakers",
                            MiddleSubButtonURL: "/speakers",
                            RightSubButtonLabel: "Roundtables",
                            RightSubButtonURL: "/roundtable"
                        },

                        LeftPanelImageTransitionDelay: '2',
                        RightPanelImageTransitionDelay: '2',
                        EnableSubButtons: false,
                        JoinButtonUrl: "/sessions",
                        HideEventName: false,
                        HamburgerBarColor: "#000000",
                        HamburgerIcon: null
                    }
                });
            } else {
                let docObj = new Object;
                let eventNameText = window.localStorage.getItem("Session_Event_FullName");
                virtuallobbyRef.get().then(function(doc) {
                    if (doc.exists) {
                        //console.log(eventNameText);
                        docObj = doc.data();                        
                        if (docObj.coundownLobby.navcolor === undefined || docObj.coundownLobby.navcolor === '') {
                            docObj.coundownLobby.navcolor = '#ffffff';
                        }
                        if (docObj.HidePhotoScrollLeft === undefined || docObj.HidePhotoScrollLeft === '' || docObj.HidePhotoScrollLeft === 'true' || docObj.HidePhotoScrollLeft === 'false') {
                            docObj.HidePhotoScrollLeft = 'ShowPhotoScrollLeftHide';
                        }
                        if (docObj.HidePhotoScrollRight === undefined || docObj.HidePhotoScrollRight === '' || docObj.HidePhotoScrollRight === 'true' || docObj.HidePhotoScrollRight === 'false') {
                            docObj.HidePhotoScrollRight = 'ShowPhotoScrollRightHide';
                        }
                        if (docObj.HideBottomMenu === undefined || docObj.HideBottomMenu === '') {
                            docObj.HidePhotoScrollRight = 'false'
                        }
                        if (docObj.AutoRedirectMicrositeWhenCountdownCompleted === undefined || docObj.AutoRedirectMicrositeWhenCountdownCompleted === '') {
                            docObj.AutoRedirectMicrositeWhenCountdownCompleted = 'Disable';
                        }
                        if (docObj.IsBackgroundMusic === undefined || docObj.IsBackgroundMusic === '' || docObj.IsBackgroundMusic === true || docObj.IsBackgroundMusic === false) {
                            docObj.IsBackgroundMusic = 'PlayAlways';
                        }
                        if (docObj.IsVideoControl === undefined || docObj.IsVideoControl === '' || docObj.IsVideoControl === true || docObj.IsVideoControl === false) {
                            docObj.IsVideoControl = 'V_ConDisable';
                        }
                        if (docObj.hostedBy === undefined || docObj.hostedBy === '') {
                            docObj.hostedBy = '';
                        }
                        if (docObj.headlineText === undefined || docObj.headlineText === '') {
                            // docObj.headlineText = eventNameText;
                        }
                        if (docObj.PhotoScrollLeftSubHeading === undefined || docObj.PhotoScrollLeftSubHeading === '') {
                            docObj.PhotoScrollLeftSubHeading = 'SPONSOR'
                        }
                        if (docObj.PhotoScrollRightSubHeading === undefined || docObj.PhotoScrollRightSubHeading === '') {
                            docObj.PhotoScrollRightSubHeading = '';
                        }
                        //-----------------LObby AdditionalButtons------------------------------------------------------------
                        if (docObj.AdditionalButtons === undefined) {
                            var AdditionalButtons = {
                                AdditionalButtons: {
                                    LeftSubButtonLabel: "",
                                    LeftSubButtonURL: "",
                                    MiddleSubButtonLabel: "",
                                    MiddleSubButtonURL: "",
                                    RightSubButtonLabel: "",
                                    RightSubButtonURL: ""
                                }
                            }
                            docObj = AdditionalButtons
                        }
                        if (docObj.AdditionalButtons === undefined || docObj.AdditionalButtons.LeftSubButtonLabel === '') {
                            docObj.AdditionalButtons.LeftSubButtonLabel = 'Attendees';
                        }
                        if (docObj.AdditionalButtons.LeftSubButtonURL === undefined || docObj.AdditionalButtons.LeftSubButtonURL === '') {
                            docObj.AdditionalButtons.LeftSubButtonURL = '/attendee';
                        }
                        if (docObj.AdditionalButtons.MiddleSubButtonLabel === undefined || docObj.AdditionalButtons.MiddleSubButtonLabel === '') {
                            docObj.AdditionalButtons.MiddleSubButtonLabel = 'Speakers';
                        }



                        if (docObj.AdditionalButtons.MiddleSubButtonURL === undefined || docObj.AdditionalButtons.MiddleSubButtonURL === '') {
                            docObj.AdditionalButtons.MiddleSubButtonURL = '/speakers';
                        }



                        if (docObj.AdditionalButtons.RightSubButtonLabel === undefined || docObj.AdditionalButtons.RightSubButtonLabel === '') {
                            docObj.AdditionalButtons.RightSubButtonLabel = 'Roundtables';
                        }

                        if (docObj.AdditionalButtons.RightSubButtonURL === undefined || docObj.AdditionalButtons.RightSubButtonURL === '') {
                            docObj.AdditionalButtons.RightSubButtonURL = '/roundtable';
                        }
                        if (docObj.LeftPanelImageTransitionDelay === undefined || docObj.LeftPanelImageTransitionDelay === '') {
                            docObj.LeftPanelImageTransitionDelay = '2';
                        }
                        if (docObj.RightPanelImageTransitionDelay === undefined || docObj.RightPanelImageTransitionDelay === '') {
                            docObj.RightPanelImageTransitionDelay = '2';
                        }
                        if (docObj.EnableSubButtons === undefined || docObj.EnableSubButtons === '') {
                            docObj.EnableSubButtons = false;
                        }
                        //------------------------------------------------------------------------------
                        if (docObj.JoinButtonUrl === undefined || docObj.JoinButtonUrl === '') {
                            docObj.JoinButtonUrl = '/sessions';
                        }

                        if (docObj.HideEventName === undefined || docObj.HideEventName === '') {
                            docObj.HideEventName = false;
                        }

                        if (docObj.HamburgerBarColor === undefined || docObj.HamburgerBarColor === '') {
                            docObj.HamburgerBarColor = '#000000';
                        }

                        if (docObj.HamburgerIcon === undefined || docObj.HamburgerIcon === '') {
                            docObj.HamburgerIcon = null;
                        }

                        if (docObj.coundownLobby === undefined) {
                            var coundownLobby = {
                                bgImageApp: "",
                                bgImagePath: "",
                                bgImageIpad: "",                                
                                HeaderTextColor: "#ffffff",
                                sponsorBorderColor: "#500a48",
                                sponsorBGColor: "#000000",
                                photoWallBorderColor: "rgba(255, 255, 255, 0.29)",
                                photoWallBGColor: "rgba(255, 255, 255, 0.29)",
                                joinButtonBGColor: "#19852e",
                                joinButtonShadowColor: "#0d551b",
                                joinButtonFontColor: "#ffffff",
                                navcolor: "#ffffff"
                            }
                            docObj.coundownLobby = coundownLobby
                        }else {
                            docObj.coundownLobby.bgImageApp = docObj.coundownLobby.bgImageApp ? docObj.coundownLobby.bgImageApp : "";
                            docObj.coundownLobby.bgImagePath = docObj.coundownLobby.bgImagePath ? docObj.coundownLobby.bgImagePath : "";
                            docObj.coundownLobby.bgImageIpad = docObj.coundownLobby.bgImageIpad ? docObj.coundownLobby.bgImageIpad : "";
                        }

                        resolve({ status: 200, data: docObj });
                    } else {
                        var data = {
                            CountDownTime: '60',
                            MusicURL: 'https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/Sounds%2Flobby_1234567890.mp3?alt=media',
                            IsBackgroundMusic: 'PlayAlways',
                            VideoURL: '',
                            VideoLength: 5,
                            IsVideoControl: 'V_ConDisable',
                            AutoRedirectMicrositeWhenCountdownCompleted: 'Disable',
                            RedirectURL: '',
                            PhotoScrollerLeft: '',
                            PhotoScrollerRight: '',
                            ImgHotspotHTML: '',
                            PhotoScrollLeftHeading: 'Thank You',
                            PhotoScrollLeftSubHeading: 'SPONSOR',
                            PhotoScrollRightHeading: 'PHOTO WALL',
                            PhotoScrollRightSubHeading: '',
                            LastModifiedDate: '',
                            HidePhotoScrollLeft: 'ShowPhotoScrollLeftHide',
                            HidePhotoScrollRight: 'ShowPhotoScrollRightHide',
                            HideBottomMenu: 'false',
                            headlineText: '', // eventNameText,
                            hostedBy: '',
                            coundownLobby: {
                                bgImageApp: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsplash-xxhdpi.png?alt=media",
                                bgImagePath: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsection-bg.jpg?alt=media",
                                bgImageIpad: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsection-bg.jpg?alt=media",
                                HeaderTextColor: "#ffffff",
                                sponsorBorderColor: "#500a48",
                                sponsorBGColor: "#000000",
                                photoWallBorderColor: "rgba(255, 255, 255, 0.29)",
                                photoWallBGColor: "rgba(255, 255, 255, 0.29)",
                                joinButtonBGColor: "#19852e",
                                joinButtonShadowColor: "#0d551b",
                                joinButtonFontColor: "#ffffff",
                                navcolor: "#ffffff"
                            },
                            AdditionalButtons: {
                                LeftSubButtonLabel: "Attendees",
                                LeftSubButtonURL: "/attendee",
                                MiddleSubButtonLabel: "Speakers",
                                MiddleSubButtonURL: "/speakers",
                                RightSubButtonLabel: "Roundtables",
                                RightSubButtonURL: "/roundtable"
                            },
                            LeftPanelImageTransitionDelay: '2',
                            RightPanelImageTransitionDelay: '2',
                            EnableSubButtons: false,
                            JoinButtonUrl: "/sessions",
                            HideEventName: false,
                            HamburgerBarColor: "#000000",
                            HamburgerIcon: null
                        };
                        resolve({
                            status: 200,
                            data: data
                        });
                    }
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error);
                    reject(error);
                });
            }
        });
    },
    addVirtuallobby(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                CountDownTime: field.data.CountDownTime ? field.data.CountDownTime : '',
                MusicURL: field.data.MusicURL ? field.data.MusicURL : '',
                IsBackgroundMusic: field.data.IsBackgroundMusic ? field.data.IsBackgroundMusic : 'PlayAlways',
                VideoURL: field.data.VideoURL ? field.data.VideoURL : '',
                VideoLength: field.data.VideoLength ? field.data.VideoLength : '',
                IsVideoControl: field.data.IsVideoControl ? field.data.IsVideoControl : 'V_ConDisable',
                AutoRedirectMicrositeWhenCountdownCompleted: field.data.AutoRedirectMicrositeWhenCountdownCompleted ? field.data.AutoRedirectMicrositeWhenCountdownCompleted : 'Disable',
                RedirectURL: field.data.RedirectURL ? field.data.RedirectURL : '',
                PhotoScrollerLeft: field.data.PhotoScrollerLeft ? field.data.PhotoScrollerLeft : '',
                PhotoScrollerRight: field.data.PhotoScrollerRight ? field.data.PhotoScrollerLeft : '',
                JoinButtonText: field.data.JoinButtonText ? field.data.JoinButtonText : '',
                // PhotoScrollerLeft:field.data.PhotoScrollerLeft.photoDirectory,
                // PhotoScrollerRight:field.data.PhotoScrollerRight.photoDirectory,
                // ImgHotspotHTML:field.data.ImgHotspotHTML,

                PhotoScrollLeftHeading: field.data.PhotoScrollLeftHeading ? field.data.PhotoScrollLeftHeading : '',
                PhotoScrollRightHeading: field.data.PhotoScrollRightHeading ? field.data.PhotoScrollRightHeading : '',
                PhotoScrollRightSubHeading: field.data.PhotoScrollRightSubHeading ? field.data.PhotoScrollRightSubHeading : '',
                PhotoScrollLeftSubHeading: field.data.PhotoScrollLeftSubHeading ? field.data.PhotoScrollLeftSubHeading : '',

                HidePhotoScrollLeft: field.data.HidePhotoScrollLeft ? field.data.HidePhotoScrollLeft : 'ShowPhotoScrollLeftHide',
                HidePhotoScrollRight: field.data.HidePhotoScrollRight ? field.data.HidePhotoScrollRight : 'ShowPhotoScrollRightHide',
                HideBottomMenu: field.data.HideBottomMenu ? field.data.HideBottomMenu : 'false',
                headlineText: field.data.headlineText ? field.data.headlineText : null,
                hostedBy: field.data.hostedBy ? field.data.hostedBy : null,
                coundownLobby: {
                    bgImageApp: field.data.coundownLobby.bgImageApp,
                    bgImagePath: field.data.coundownLobby.bgImagePath,
                    bgImageIpad: field.data.coundownLobby.bgImageIpad,
                    HeaderTextColor: field.data.coundownLobby.HeaderTextColor,
                    sponsorBorderColor: field.data.coundownLobby.sponsorBorderColor,
                    sponsorBGColor: field.data.coundownLobby.sponsorBGColor,
                    photoWallBorderColor: field.data.coundownLobby.photoWallBorderColor,
                    photoWallBGColor: field.data.coundownLobby.photoWallBGColor,
                    joinButtonBGColor: field.data.coundownLobby.joinButtonBGColor,
                    joinButtonShadowColor: field.data.coundownLobby.joinButtonShadowColor,
                    joinButtonFontColor: field.data.coundownLobby.joinButtonFontColor,
                    navcolor: field.data.coundownLobby.navcolor
                },
                AdditionalButtons: {
                    LeftSubButtonLabel: field.data.AdditionalButtons.LeftSubButtonLabel,
                    LeftSubButtonURL: field.data.AdditionalButtons.LeftSubButtonURL,
                    MiddleSubButtonLabel: field.data.AdditionalButtons.MiddleSubButtonLabel,
                    MiddleSubButtonURL: field.data.AdditionalButtons.MiddleSubButtonURL,
                    RightSubButtonLabel: field.data.AdditionalButtons.RightSubButtonLabel,
                    RightSubButtonURL: field.data.AdditionalButtons.RightSubButtonURL
                },
                LeftPanelPhotoWallAlbum: (field.data.LeftPanelPhotoWallAlbum != undefined ? field.data.LeftPanelPhotoWallAlbum : []),
                RightPanelPhotoWallAlbum: (field.data.RightPanelPhotoWallAlbum != undefined ? field.data.RightPanelPhotoWallAlbum : []),
                LeftPanelImageTransitionDelay: field.data.LeftPanelImageTransitionDelay,
                RightPanelImageTransitionDelay: field.data.RightPanelImageTransitionDelay,
                LastModifiedDate: new Date().toString(),
                JoinButtonUrl: field.data.JoinButtonUrl,
                HideEventName: field.data.HideEventName ? field.data.HideEventName : false,
                HamburgerBarColor: field.data.HamburgerBarColor ? field.data.HamburgerBarColor : "#000000",
                HamburgerIcon: field.data.HamburgerIcon ? field.data.HamburgerIcon : null
            }
            var refDoc = virtuallobbyRef;
            refDoc.get().then(function(doc) {
                ////////////////////////////////
                /////////// Update Function/////////
                //////////////////////////
                if (doc.exists) {
                    virtuallobbyRef.update({
                        CountDownTime: field.data.CountDownTime ? field.data.CountDownTime : '',
                        MusicURL: field.data.MusicURL ? field.data.MusicURL : '',
                        IsBackgroundMusic: field.data.IsBackgroundMusic ? field.data.IsBackgroundMusic : '',
                        VideoURL: field.data.VideoURL ? field.data.VideoURL : '',
                        VideoLength: field.data.VideoLength ? field.data.VideoLength : '',
                        IsVideoControl: field.data.IsVideoControl ? field.data.IsVideoControl : '',
                        AutoRedirectMicrositeWhenCountdownCompleted: field.data.AutoRedirectMicrositeWhenCountdownCompleted ? field.data.AutoRedirectMicrositeWhenCountdownCompleted : 'Disable',
                        RedirectURL: field.data.RedirectURL ? field.data.RedirectURL : '',

                        PhotoScrollerLeft: field.data.PhotoScrollerLeft ? field.data.PhotoScrollerLeft : '',
                        PhotoScrollerRight: field.data.PhotoScrollerRight ? field.data.PhotoScrollerRight : '',
                        JoinButtonText: field.data.JoinButtonText ? field.data.JoinButtonText : '',
                        // PhotoScrollerLeft:field.data.PhotoScrollerLeft.photoDirectory,
                        // PhotoScrollerRight:field.data.PhotoScrollerRight.photoDirectory,

                        PhotoScrollLeftHeading: field.data.PhotoScrollLeftHeading ? field.data.PhotoScrollLeftHeading : '',
                        PhotoScrollRightHeading: field.data.PhotoScrollRightHeading ? field.data.PhotoScrollRightHeading : '',
                        PhotoScrollRightSubHeading: field.data.PhotoScrollRightSubHeading ? field.data.PhotoScrollRightSubHeading : '',
                        PhotoScrollLeftSubHeading: field.data.PhotoScrollLeftSubHeading ? field.data.PhotoScrollLeftSubHeading : '',

                        HidePhotoScrollLeft: field.data.HidePhotoScrollLeft ? field.data.HidePhotoScrollLeft : 'ShowPhotoScrollLeftHide',
                        HidePhotoScrollRight: field.data.HidePhotoScrollRight ? field.data.HidePhotoScrollRight : 'ShowPhotoScrollRightHide',
                        HideBottomMenu: field.data.HideBottomMenu ? field.data.HideBottomMenu : 'false',
                        headlineText: field.data.headlineText ? field.data.headlineText : null,
                        hostedBy: field.data.hostedBy ? field.data.hostedBy : null,

                        coundownLobby: {
                            bgImageApp: field.data.coundownLobby.bgImageApp,
                            bgImagePath: field.data.coundownLobby.bgImagePath,
                            bgImageIpad: field.data.coundownLobby.bgImageIpad,
                            HeaderTextColor: field.data.coundownLobby.HeaderTextColor,
                            sponsorBorderColor: field.data.coundownLobby.sponsorBorderColor,
                            sponsorBGColor: field.data.coundownLobby.sponsorBGColor,
                            photoWallBorderColor: field.data.coundownLobby.photoWallBorderColor,
                            photoWallBGColor: field.data.coundownLobby.photoWallBGColor,
                            joinButtonBGColor: field.data.coundownLobby.joinButtonBGColor,
                            joinButtonShadowColor: field.data.coundownLobby.joinButtonShadowColor,
                            joinButtonFontColor: field.data.coundownLobby.joinButtonFontColor,
                            navcolor: field.data.coundownLobby.navcolor
                        },
                        AdditionalButtons: {
                            LeftSubButtonLabel: field.data.AdditionalButtons.LeftSubButtonLabel,
                            LeftSubButtonURL: field.data.AdditionalButtons.LeftSubButtonURL,
                            MiddleSubButtonLabel: field.data.AdditionalButtons.MiddleSubButtonLabel,
                            MiddleSubButtonURL: field.data.AdditionalButtons.MiddleSubButtonURL,
                            RightSubButtonLabel: field.data.AdditionalButtons.RightSubButtonLabel,
                            RightSubButtonURL: field.data.AdditionalButtons.RightSubButtonURL
                        },
                        LeftPanelPhotoWallAlbum: field.data.LeftPanelPhotoWallAlbum ? field.data.LeftPanelPhotoWallAlbum : [],
                        RightPanelPhotoWallAlbum: field.data.RightPanelPhotoWallAlbum ? field.data.RightPanelPhotoWallAlbum : [],
                        LeftPanelImageTransitionDelay: field.data.LeftPanelImageTransitionDelay,
                        RightPanelImageTransitionDelay: field.data.RightPanelImageTransitionDelay,
                        LastModifiedDate: new Date().toString(),
                        JoinButtonUrl: field.data.JoinButtonUrl,
                        HideEventName: field.data.HideEventName ? field.data.HideEventName : false,
                        HamburgerBarColor: field.data.HamburgerBarColor ? field.data.HamburgerBarColor : "#000000",
                        HamburgerIcon: field.data.HamburgerIcon ? field.data.HamburgerIcon : null
                    }).then(function(doc) {
                        context.dispatch('uploadFile', { path: docObj.EventCollectionName + '/Virtuallobby/music/', file: field.data.musicfile }).then(musicUrl => {
                            context.dispatch('uploadFile', { path: docObj.EventCollectionName + '/Virtuallobby/event/', file: field.data.bgImgfile }).then(bgImg => {
                                if (musicUrl) {
                                    //docObj.MusicURL = musicUrl;
                                    virtuallobbyRef.update({
                                        MusicURL: musicUrl.toString().split('&token').slice(0, -1).join('.'),
                                    })
                                }
                                if (bgImg) {
                                    //docObj.MusicURL = musicUrl;
                                    virtuallobbyRef.update({
                                        coundownLobby: {
                                            bgImageApp: bgImg.toString().split('&token').slice(0, -1).join('.'),
                                            bgImagePath: bgImg.toString().split('&token').slice(0, -1).join('.'),
                                            bgImageIpad: bgImg.toString().split('&token').slice(0, -1).join('.'),
                                            HeaderTextColor: field.data.coundownLobby.HeaderTextColor,
                                            sponsorBorderColor: field.data.coundownLobby.sponsorBorderColor,
                                            sponsorBGColor: field.data.coundownLobby.sponsorBGColor,
                                            photoWallBorderColor: field.data.coundownLobby.photoWallBorderColor,
                                            photoWallBGColor: field.data.coundownLobby.photoWallBGColor,
                                            joinButtonBGColor: field.data.coundownLobby.joinButtonBGColor,
                                            joinButtonShadowColor: field.data.coundownLobby.joinButtonShadowColor,
                                            joinButtonFontColor: field.data.coundownLobby.joinButtonFontColor,
                                            navcolor: field.data.coundownLobby.navcolor
                                        }
                                    })
                                }
                                //let musicFile = musicUrl.toString().split('&token').slice(0, -1).join('.')  
                                //let bgFile = bgImg.toString().split('&token').slice(0, -1).join('.') 
                                resolve({ status: 200, message: 'Data & File Updated.' })
                            })
                        })

                    }).catch(function(error) {
                        //console.log('Error getting update attendee:', error)
                        reject(error)
                    })
                }
                ////////////////////////////////////
                /////////// New Added Function/////////
                //////////////////////////////////
                else {
                    //alert("no-exist")
                    refDoc.set(docObj).then(function() {
                        // if(field.data.videofile) {
                        //   const file = field.data.videofile
                        //   const metadata = {'contentType': file.type}
                        //   storageRef.child(`${cn}/Virtuallobby/video/${  new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function (snapshot) {
                        //     snapshot.ref.getDownloadURL().then(function (url) {  
                        //       virtuallobbyRef.update({ 
                        //         VideoURL:url.toString(),
                        //       }).then(function (doc) {                      
                        //         resolve({status:200, message:'Data & File Updated.'})
                        //         console.log(url);
                        //       }).catch(function (error) {   
                        //         console.log('data update '+error)                
                        //       })                          
                        //     }).catch(function (error) {   
                        //       console.log('download url '+error)                
                        //     })
                        //   }).catch(function (error) {   
                        //     console.log('imgae upload '+error)                
                        //   })
                        // }              
                        context.dispatch('uploadFile', { path: docObj.EventCollectionName + '/Virtuallobby/music/', file: field.data.musicfile }).then(musicUrl => {
                                context.dispatch('uploadFile', { path: docObj.EventCollectionName + '/Virtuallobby/event/', file: field.data.bgImgfile }).then(bgImg => {
                                    if (musicUrl) {
                                        //docObj.MusicURL = musicUrl;
                                        virtuallobbyRef.update({
                                            MusicURL: musicUrl.toString().split('&token').slice(0, -1).join('.'),
                                        })
                                    }
                                    if (bgImg) {
                                        //docObj.MusicURL = musicUrl;
                                        virtuallobbyRef.update({
                                            coundownLobby: {
                                                bgImageApp: bgImg.toString().split('&token').slice(0, -1).join('.'),
                                                bgImagePath: bgImg.toString().split('&token').slice(0, -1).join('.'),
                                                bgImageIpad: bgImg.toString().split('&token').slice(0, -1).join('.'),
                                                HeaderTextColor: field.data.coundownLobby.HeaderTextColor,
                                                sponsorBorderColor: field.data.coundownLobby.sponsorBorderColor,
                                                sponsorBGColor: field.data.coundownLobby.sponsorBGColor,
                                                photoWallBorderColor: field.data.coundownLobby.photoWallBorderColor,
                                                photoWallBGColor: field.data.coundownLobby.photoWallBGColor,
                                                joinButtonBGColor: field.data.coundownLobby.joinButtonBGColor,
                                                joinButtonShadowColor: field.data.coundownLobby.joinButtonShadowColor,
                                                joinButtonFontColor: field.data.coundownLobby.joinButtonFontColor,
                                                navcolor: field.data.coundownLobby.navcolor
                                            }
                                        })
                                    }
                                    //let musicFile = musicUrl.toString().split('&token').slice(0, -1).join('.')  
                                    //let bgFile = bgImg.toString().split('&token').slice(0, -1).join('.') 
                                    resolve({ status: 200, message: 'Data & File Updated.' })
                                })
                            })
                            //resolve({status:200, message:'Data Added.'})
                    }).catch(function(error) {
                        reject(error)
                        console.log(error);
                    })
                }
            });
        });
    },
    uploadFile(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = { 'contentType': file.type }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function(snapshot) {
                    snapshot.ref.getDownloadURL().then(function(url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve('')
            }
        })
    },
    updateVirtuallobbyImageHotspot(context, field) {

  
        return new Promise((resolve, reject) => {
            let docObj = {
                CountDownTime: '60',
                MusicURL: 'https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/Sounds%2Flobby_1234567890.mp3?alt=media',
                IsBackgroundMusic: 'PlayAlways',
                VideoURL: '',
                VideoLength: 5,
                IsVideoControl: 'V_ConDisable',
                AutoRedirectMicrositeWhenCountdownCompleted: 'Disable',
                RedirectURL: '',
                PhotoScrollerLeft: '',
                PhotoScrollerRight: '',
                ImgHotspotHTML: '',
                PhotoScrollLeftHeading: 'Thank You',
                PhotoScrollLeftSubHeading: 'SPONSOR',
                PhotoScrollRightHeading: 'PHOTO WALL',
                PhotoScrollRightSubHeading: '',
                LastModifiedDate: '',
                HidePhotoScrollLeft: 'ShowPhotoScrollLeftHide',
                HidePhotoScrollRight: 'ShowPhotoScrollRightHide',
                HideBottomMenu: 'false',
                headlineText: '',
                hostedBy: '',
                coundownLobby: {
                    bgImageApp: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsplash-xxhdpi.png?alt=media",
                    bgImagePath: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsection-bg.jpg?alt=media",
                    bgImageIpad: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsection-bg.jpg?alt=media",
                    HeaderTextColor: "#ffffff",
                    sponsorBorderColor: "#500a48",
                    sponsorBGColor: "#000000",
                    photoWallBorderColor: "rgba(255, 255, 255, 0.29)",
                    photoWallBGColor: "rgba(255, 255, 255, 0.29)",
                    joinButtonBGColor: "#19852e",
                    joinButtonShadowColor: "#0d551b",
                    joinButtonFontColor: "#ffffff",
                    navcolor: "#ffffff"
                },
                LastModifiedDate: new Date().toString()
            }

            var refDoc = virtuallobbyRef;
            refDoc.get().then(function(doc) {
                if (doc.exists) {
                    if(field.data.ImgHotspotHTML != null || field.data.ImgHotspotHTML != undefined){
                        virtuallobbyRef.update({
                            MusicURL: field.data.MusicURL ? field.data.MusicURL : '',
                            ImgHotspotHTML: field.data.ImgHotspotHTML,
                            LastModifiedDate: new Date().toString()
                        }).then(function(doc) {
                            context.dispatch('uploadFile', { path: docObj.EventCollectionName + '/Virtuallobby/music/', file: field.data.musicfile }).then(musicUrl => {
                                    if (musicUrl) {
                                        //docObj.MusicURL = musicUrl;
                                        virtuallobbyRef.update({
                                            MusicURL: musicUrl.toString().split('&token').slice(0, -1).join('.'),
                                        })
                                    }
                                    resolve({ status: 200, message: 'Data & File Updated.' })
                            })
                        })

                    }else if(field.data.IsMusicEnable != null || field.data.IsMusicEnable != undefined){
                               virtuallobbyRef.update({
                            IsMusicEnable: field.data.IsMusicEnable,
                            LastModifiedDate: new Date().toString()
                        }).then(function(doc) {
                            resolve({ status: 200, message: 'Data Updated.' })
                        })

                    }else if(field.data.ImageUrl != null || field.data.ImageUrl != undefined){
                        virtuallobbyRef.update({
                            ImageUrl: field.data.ImageUrl,
                            LastModifiedDate: new Date().toString()
                        }).then(function(doc) {
                            resolve({ status: 200, message: 'Data Updated.' })
                        })
                    }
                    else if(field.data.IsHotspotEnable != null || field.data.IsHotspotEnable != undefined){
                        virtuallobbyRef.update({
                            IsHotspotEnable: field.data.IsHotspotEnable,
                            LastModifiedDate: new Date().toString()
                        }).then(function(doc) {
                            resolve({ status: 200, message: 'Data Updated.' })
                        })
                    }else if(field.data.IsMouseCursorEnable != null || field.data.IsMouseCursorEnable != undefined){
                               virtuallobbyRef.update({
                                IsMouseCursorEnable: field.data.IsMouseCursorEnable,
                            LastModifiedDate: new Date().toString()
                        }).then(function(doc) {
                            resolve({ status: 200, message: 'Data Updated.' })
                        })
                    }
                    // else if(field.data.MusicURL != null || field.data.MusicURL != undefined && field.data.ImgHotspotHTML == undefined){
                    //     virtuallobbyRef.update({
                    //         MusicURL: field.data.MusicURL,
                    //         LastModifiedDate: new Date().toString()
                    //     }).then(function(doc) {
                    //         resolve({ status: 200, message: 'Data Updated.' })
                    //     })
                    // }
                } else {
                    refDoc.set(docObj).then(function() {
                        resolve({ status: 200, message: 'Data Added.' })
                    }).catch(function(error) {
                        reject(error)
                        console.log(error);
                    })
                }
            });

        });


    },
    // updating evnt info
    updateLobbyType(context, LobbyType) {
        return new Promise((resolve, reject) => {
            eventInfoRef.update({
                    LobbyType: LobbyType,
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Custom HTML Updated.' })
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },
    CreateDefaultLobby(context, fields) {
        alert("lobby");
        return new Promise((resolve, reject) => {
            if (fields.id) {
                context.dispatch('fetchVirtuallobby', fields.id).then(function(lobby) {
                    if (lobby) {
                        //PENDING
                        resolve('');
                    }
                });
            }
        });
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function(snapshot) {
                    snapshot.ref.getDownloadURL().then(function(url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve(null)
            }
        })
    },
    updateVirtualLobbySubButtonStatus(context, SubButtons) {
        var refDoc = virtuallobbyRef;
        refDoc.get().then(function(doc) {
            ////////////////////////////////
            /////////// Update Function/////////
            //////////////////////////
            if (doc.exists) {
                virtuallobbyRef.update({

                    EnableSubButtons: SubButtons,
                }).then(function(doc) {
                    resolve({ status: 200, message: 'Custom HTML Updated.' })
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
            }
        });
    },
    fetchVirtualLobbyTemplates(context, pageName) {
        return new Promise((resolve, reject) => {
            let markers = []
            virtualLobbyTemplates.orderBy("TemplateName", "asc").get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data());
                });

                resolve({ status: 200, data: markers })
            }).catch(function(error) {
                reject(error)
            })
        })
    },
    fetchVirtualLobbySettings(context) {
        return new Promise((resolve, reject) => {
                let docObj = new Object;
                virtuallobbyRef.get().then(function(doc) {
                    if (doc.exists) {            
                        docObj = doc.data();                     
                        resolve({ status: 200, data: docObj });
                    }
                }).catch(function(error) {
                    reject(error);
                });
            
        });
    },

}